import {
    loadScript,
    subscribeEvent,
} from 'methods/utils';

function share2Fn() {
    loadScript('https://yastatic.net/share2/share.js').then(() => {
        const Ya = global.Ya;

        Ya.share2(document.querySelector('#js-share-blog'));
    });
}
subscribeEvent('share2Fn', share2Fn);
